import styled, { css, keyframes } from 'styled-components';
import { BellOutline, BlackButton, TypographyStyles, colours, media, zMobileAddToBag } from '@storefront/lib-global';

const lineAnimation = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(99%);
  }
`;

const showIcon = keyframes`
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const AddToBagWrapper = styled.div<{ $isZoomed: boolean }>`
  align-items: center;
  background-color: ${colours.WHITE};
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  margin-top: 20px;
  padding: 5px;
  position: ${({ $isZoomed }) => ($isZoomed ? 'block' : 'fixed')};
  width: 100%;
  z-index: ${zMobileAddToBag};

  @media ${media.greaterThan('lg')} {
    display: block;
    margin-top: 12px;
    padding: 0;
    position: static;
    z-index: unset;
  }
`;
export const StyledAddToBag = styled(BlackButton)<{ $addToBagLoading: boolean }>`
  height: 50px;
  justify-content: center;
  margin: 0;
  padding: 0;
  position: relative;
  width: 100%;

  &:disabled {
    ${({ $addToBagLoading }) =>
      !$addToBagLoading
        ? css`
            align-items: center;
            background-color: ${colours.LIGHT_GREY_2};
            border: 1px solid ${colours.MID_GREY};
            color: ${colours.GREY};
            cursor: not-allowed;
            display: flex;
          `
        : css`
            background-color: ${colours.BLACK};
            border: 0;
            color: ${colours.WHITE};
            cursor: wait;
          `}
  }

  @media ${media.greaterThan('md')} {
    max-width: 523px;

    &:focus-visible {
      transform: translateX(1%);
      width: 98%;
    }
  }
`;
export const ErrorMessage = styled.p`
  color: ${colours.ERROR_PRIMARY};
  margin-bottom: 0;
  ${TypographyStyles.Body.Tiny.SemiBold}
`;
export const BellIcon = styled(BellOutline)`
  margin-right: 10px;
`;
export const LoaderAnimation = styled.div`
  background-color: ${colours.NAVY_BLUE};
  bottom: 2px;
  height: 4px;
  position: absolute;
  width: 100%;

  &::before {
    animation: ${lineAnimation} 0.3s linear forwards;
    background-color: ${colours.VERY_LIGHT_GREY};
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    width: 100%;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
      background-color: none;
      height: 0;
      width: 0;
    }
  }
`;
export const IconContainer = styled.div<{ $isPdpSkuCap: boolean }>`
  & > svg > path {
    fill: ${({ $isPdpSkuCap }) => ($isPdpSkuCap ? colours.BLACK : colours.WHITE)};
  }

  & > svg {
    animation: ${showIcon} 0.3s linear forwards;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  }
`;
